(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleUserWithoutCafDeleteController',MultipleUserWithoutCafDeleteController);

    MultipleUserWithoutCafDeleteController.$inject = ['$uibModalInstance', 'entity', 'MultipleUserWithoutCaf'];

    function MultipleUserWithoutCafDeleteController($uibModalInstance, entity, MultipleUserWithoutCaf) {
        var vm = this;

        vm.multipleUserWithoutCaf = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MultipleUserWithoutCaf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
